export default __webpack_public_path__ + "static/media/appexibition.64766ff9.png";